<template>
    <div class="login">
        <div class="box_card">
            <img src="../../assets/images/logo_box_img.png" alt="" class='login_box_img'>

            <div class="login_operation_box">
                <h1>企鹊桥企业管理后台</h1>

                <h4>非企鹊桥用户，请先在企鹊桥APP上完成注册</h4>

                <div class="phone_input_box">
                    <el-input v-model="phone_number" type="number" :maxlength="11" placeholder="请输入手机号" class="phone_input"></el-input>
                </div>

                <div class='ver_code_box'>
                    <el-input v-model="ver_code" type="number" :maxlength="6" placeholder="请输入验证码"></el-input>
                    <el-button type="primary" class="code_button" @click="getVercode" :disabled='getCode_button.disable'>{{getCode_button.button_text}}</el-button>
                </div>

                <el-checkbox v-model="checked">下次自动登录</el-checkbox>

                <el-button type="primary" class="login_button" :loading="in_login" @click="login">登录</el-button>
            </div>
        
        </div>

        <p class="copyright">©2019 杭州鑫牛科技有限公司</p>
    </div>
</template>

<script>
import request from "../../libs/api/request.js"
import md5 from 'js-md5';
import { getUserInfo } from "../../libs/api/getUserInfo.js"

export default {
    name: "Login",
    data (){
        return {
            checked: true,      //是否自动登录
            phone_number: "",
            ver_code: "",

            getCode_button: {
                disable: false,
                button_text: "获取验证码",
            },
            in_login: false
        }
    },
    methods:{
        // 获取验证码
        getVercode(){
            let that = this;

            if(that.phone_number == "" || that.phone_number.length !== 11){
                that.$message({
                    type: "warning",
                    message: "请输入正确的手机号"
                })

                return;
            }

            that.$request.post({
                need_login: false,
                url: "/api/v2/sendCode",
                params: {
                    mobile: that.phone_number,
                    sign: md5(that.phone_number + "Aq8NB-Y6=LBs25KSl0P"),
                    type: 3,
                    platform: 2
                },
                headers: {
                    identif: "qiqueqiao.com"
                }
            }).then(res => {
                that.$message({
                    message: res.msg,
                    type: 'success'
                })

                that.getCode_button.disable = true;

                that.getCode_button.button_text = 60;
                let countdown = setInterval(function(){
                    that.getCode_button.button_text--;

                    if(that.getCode_button.button_text <= 0){
                        that.getCode_button.button_text = "获取验证码";
                        that.getCode_button.disable = false;

                        clearInterval(countdown);
                    }
                },1000)
            })
        },
        login(){
            let that = this;

            if(that.phone_number == "" || that.phone_number.length !== 11){
                that.$message({
                    type: "warning",
                    message: "请输入正确的手机号"
                })

                return;
            }

            if(that.ver_code == ""){
                that.$message({
                    type: "warning",
                    message: "请输入正确的验证码"
                })

                return;
            }

            that.in_login = true;

            that.$request.post({
                need_login: false,
                url: "/corporate/login",
                params: {
                    mobile: that.phone_number,
                    code: that.ver_code
                }
            }).then(res => {
                if(that.checked){
                    localStorage.users = JSON.stringify(res.data);
                } else {
                    sessionStorage.users = JSON.stringify(res.data);
                }

                that.in_login = false;
                that.$message({
                    message: "登录成功",
                    type: "success",
                    duration: 1500,
                    onClose(){

                        getUserInfo().then(res => {
                            
                            // 判断用户是否已有所属公司,若没有
                            if(res.data.is_certified == 0){
                                that.$router.push("/corcert");
                            } 
                            // 判断用户所属公司是否审核通过，若正在审核中
                            else if(res.data.is_certified == 1){
                                that.$router.push("/notallow");
                            }
                            // 用户已有所属公司且公司审核通过
                            else if(res.data.is_certified == 2){
                                // 判断用户是否已被所属公司开通管理权限，若没有
                                if(res.data.type == 3){
                                    that.$router.push("/notallow");
                                } else {
                                     that.$router.push("/index");
                                }
                            }
                        })
                    }
                })
            }).catch((err) => {
                that.in_login = false;
            });
        }
    },
    mounted(){
        if(localStorage.users || sessionStorage.users){
            this.$router.push("/index");
        }
    }
}
</script>

<style lang="stylus" scoped>
.login >>>.el-input__inner::-webkit-outer-spin-button,.login >>>.el-input__inner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none; 
    margin: 0;
    color red 
}

.login >>>.el-input__inner,.login >>>.el-input__inner {
    -moz-appearance:textfield;
}

.login
    width 100%
    height 100vh
    display flex
    flex-flow column
    align-items center
    justify-content center
    background url('../../assets/images/login_bg.png') center center no-repeat
    background-size 100% 100%
    user-select none
    .box_card
        width 900px
        height 520px
        background white
        border-radius 10px
        overflow hidden
        position relative
        .login_box_img
            width 540px
            height 100%
            position absolute
            left 0
            top 0
            bottom 0
        .login_operation_box
            width 310px
            height 100%
            padding 80px 0 0
            position absolute
            top 0
            right 65px
            bottom 0
            box-sizing border-box
            overflow hidden
            h1
                font-size 28px
                line-height 26px
                font-family MicrosoftYaHeiSemibold
                color #083FA2
            h4
                font-size 14px
                line-height 14px
                text-align left 
                margin 13px 0 0
                color #999999
            .phone_input_box
                width 100%
                margin 80px 0 0
            .ver_code_box
                width 100%
                display flex
                align-items center
                justify-content space-between
                margin 44px 0 25px
                .code_button
                    width 113px
                    margin 0 0 0 30px
                    text-align center
            .login_button
                width 100%
                margin 30px 0 0
                font-size 18px
    .copyright
        font-size 14px
        color white
        margin 40px 0 0
</style>




// WEBPACK FOOTER //
// src/pages/login/Login.vue